import { useTheme } from '@emotion/react';
import { useState } from 'react';

export const useLayoutVariables = () => {
  const theme = useTheme();

  // This styling will be applied to a <NavLink> when the
  // route that it links to is currently selected.
  const activeStyle = {
    textDecoration: 'underline',
  };
  const activeClassName = 'underline';

  const [open, setOpen] = useState(false);
  const [openMenuSupport, setOpenMenuSupport] = useState(false);
  const [openMenuSales, setOpenMenuSales] = useState(false);
  const [openMenuMarketing, setOpenMenuMarketing] = useState(false);
  const [openMenuManager, setOpenMenuManager] = useState(false);
  const [openMenuReportsSales, setOpenMenuReportsSales] = useState(false);
  const [openMenuReportsLines, setOpenMenuReportsLines] = useState(false);
  const [openMenuReportsPortability, setOpenMenuReportsPortability] = useState(false);
  const [openMenuAccounting, setOpenMenuAccounting] = useState(false);
  const [openShipping, setOpenShipping] = useState(false);
  const [openSaleTransfer, setOpenSaleTransfer] = useState(false);
  const [paymentSuppliers, setOpenPaymentSuppliers] = useState(false);
  const [openMenuVinculation, setOpenMenuVinculation] = useState(false);
  const [openMenuMTCenter, setOpenMenuMTCenter] = useState(false);
  const [openMenuReportsIft, setOpenMenuReportsIft] = useState(false);
  const [openLineAssignments, setOpenLineAssignments] = useState(false);

  return {
    layoutVariables: {
      //Styles theme:
      theme,

      //NavLink active style:
      activeStyle,
      activeClassName,

      //State variables:
      open,
      setOpen,
      openMenuSupport,
      setOpenMenuSupport,
      openMenuSales,
      setOpenMenuSales,
      openMenuMarketing,
      setOpenMenuMarketing,
      openMenuManager,
      setOpenMenuManager,
      openMenuReportsSales,
      setOpenMenuReportsSales,
      openMenuReportsLines,
      setOpenMenuReportsLines,
      openMenuReportsPortability,
      setOpenMenuReportsPortability,
      openMenuAccounting,
      setOpenMenuAccounting,
      openShipping,
      setOpenShipping,
      openSaleTransfer,
      setOpenSaleTransfer,
      paymentSuppliers,
      setOpenPaymentSuppliers,
      openMenuVinculation,
      setOpenMenuVinculation,
      openMenuMTCenter,
      setOpenMenuMTCenter,
      openMenuReportsIft,
      setOpenMenuReportsIft,
      openLineAssignments,
      setOpenLineAssignments,
    },
  };
};
